import styled from '@emotion/styled';

import { getColor } from '../../common/UICommon';
import { TabletWidth } from '../../../global.style';

export const DownloadBox = styled.div`
  padding: 24px;
  border-radius: 16px;
  border: 2px solid ${getColor('PURPLE_60')};
  background-color: ${getColor('WHITE')};
  margin-top: 60px;

  @media (max-width: ${TabletWidth}px) {
    padding: 24px 32px;
    margin-top: 32px;
  }
`;

export const DownloadBoxText = styled.p`
  font-size: 20px;
  line-height: 30px;
  color: ${getColor('GRAY_80')};

  @media (max-width: ${TabletWidth}px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const DownloadBoxButtonsWrapper = styled.div`
  margin-top: 24px;
  display: inline-flex;
  align-items: flex-start;
  gap: 16px;

  @media (max-width: ${TabletWidth}px) {
    margin-top: 32px;
    justify-content: center;
  }
`;

export const DownloadBoxButton = styled.button`
  width: 100%;
  padding: 0;
  background-color: transparent;
  outline: none;
  border: none;
  cursor: pointer;

  @media (max-width: ${TabletWidth}px) {
    max-width: 210px;
  }
`;

export const DownloadBoxButtonImg = styled.img`
  width: 100%;
  height: 60px;
`;
